import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import BusinessPartnersContent from '../../components/Pages/BusinessPartners';

const { displayName } = config;

export default function BusinessPartners(): React.ReactNode | null {
  document.title = `${displayName}: Business Partners`;

  return (
    <Layout
      title="Business Partners"
    >
      <BusinessPartnersContent />
    </Layout>
  );
}
